
 <div class="header-bg">
  <mat-toolbar color="primary" class="main-header justify-content-between" >
      <div class="menu-icon d-flex align-items-center">
        <div>
          <button mat-icon-button (click)="callSidemenuCollapse()" class="sidemenu-collapse">
            <img [src]="toggleIcon" alt="">
          </button>
        </div>
        <div><a class="add-oppo" routerLink="">{{sideListMenuName | translate }}</a></div>
      </div>
    
      <div class="user-menu tools-wrapper">
        <div class="language-menu-new">
          <mat-form-field>
            <mat-select [(ngModel)]="userLanguageSelect" name='language' (selectionChange)='onLanguageChange($event)'>
              <mat-select-trigger>
                <span >
                  <img [src]="(userLanguageSelect === 'en') ? flagEng : italianFlag" alt=""> {{(userLanguageSelect === 'en') ? 'ENGLISH (EN)' : 'ITALIANO (ITA)' }}
                </span>
              </mat-select-trigger>
              <mat-option value="it" ><img style="margin-right:10px" [src]="italianFlag" alt="">{{ 'HEADER.ita' | translate}} </mat-option>
              <mat-option value="en" ><img style="margin-right:10px" [src]="flagEng" alt="">{{ 'HEADER.en' | translate}} </mat-option>
            </mat-select>
          </mat-form-field>
      
        <button mat-button [matMenuTriggerFor]="usermenu">
          <div class="user-profile-info">
            <div class="user-profile-img">
             
            </div>
            <div class="users-name">{{CustomerName}}</div>
            <span class="material-icons">expand_more</span>
          </div>
        </button>
        <mat-menu #usermenu="matMenu" class="profile-dropdown">
      
          <button class="d-flex align-items-center" mat-menu-item  routerLink="my-account/edit-profile">
            <mat-icon class="material-icons">perm_identity</mat-icon> {{'MYACCOUNT.EditProfile' | translate}}
         </button>

            <button class="d-flex align-items-center" mat-menu-item routerLink="my-account/change-password">
              <mat-icon class="material-icons">perm_identity</mat-icon>   {{'MYACCOUNT.ChangePassword' | translate}}
            </button>
         
          <button mat-menu-item class="d-flex align-items-center" (click)="logout()">
            <mat-icon class="material-icons" >{{'logout' | translate}}</mat-icon>
            {{'GENERAL.Logout' | translate}}
          </button>
        </mat-menu>
      </div>
    </div>
      
  </mat-toolbar>
</div> 
  
  





